import { MORTGAGE_LIMITS } from "shared/CalculatorLimits";
import { getLtv } from "shared/getLtv";
import { getMaxLoanValue } from "shared/getMaxLoanValue";
import { getMonthlyInstalment } from "shared/getMonthlyInstalment";
import { findBankRates } from "web_myplann/Calculators/Utils/findBankRates";
import { findLowestBankRate } from "web_myplann/Calculators/Utils/findLowestBankRate";
import type { MortgageRateResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type Params = {
	propertyPrice: number;
	loanValue: number;
	years: number;
	rates: MortgageRateResponseDTO[];
};

export const getMortgagePlan = ({
	propertyPrice,
	loanValue,
	years,
	rates,
}: Params) => {
	const maxLoanValue = getMaxLoanValue({
		propertyPrice,
		ratio: MORTGAGE_LIMITS.loanRatio,
		cap: MORTGAGE_LIMITS.loanCap,
		step: MORTGAGE_LIMITS.loanStep,
		rounding: "floor",
	});
	const actualLoanValue = Math.min(loanValue, maxLoanValue);
	const ltv = getLtv(actualLoanValue, propertyPrice);
	const bankRates = findBankRates(ltv, actualLoanValue, years, rates);
	const rate = findLowestBankRate(bankRates);
	const monthlyPayment =
		rate === undefined || actualLoanValue === 0
			? 0
			: getMonthlyInstalment(rate, years, actualLoanValue);

	return {
		maxLoanValue,
		actualLoanValue,
		ltv,
		bankRates,
		rate,
		monthlyPayment,
	};
};
